<template>
    <div v-if="!hide">
        <span class="ml-2 action-icon" @click="$bvModal.show(removeAllId)">
            <font-awesome-icon :icon="['fas', 'trash']" />
        </span>
        <modal :id="removeAllId" title="Remove All" @ok="removeAll">
            Are you sure you want to delete all messages?
        </modal>
    </div>
</template>

<script>
import Modal from '../../../generic/modal/modal.vue';

export default {
    components: {
        Modal,
    },
    data() {
        return {
            busy: false,
            removeAllId: 'remove-all-id',
        };
    },
    computed: {
        hide() {
            return !!this.params.hideColumn();
        },
    },
    methods: {
        removeAll() {
            this.params.removeAll();
        },
    },
};
</script>

<style lang="scss" scoped>
.action-icon {
    cursor: pointer;
    color: #6c757d;
    &:hover {
        opacity: 0.8;
    }
}
</style>
